import React, {
  useState,
  useEffect
} from 'react';

import { makeStyles } from '@material-ui/core/styles';
import {
  Paper,
  Typography,
  List,
  ListSubheader,
  ListItem,
  ListItemIcon,
  ListItemText,
  Divider,
} from '@material-ui/core';
import OpenInNewIcon from '@material-ui/icons/OpenInNew';
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';

import localization from '../../../utils/localizations';
import {
  BaseAPI,
} from '../../../data/BaseAPI';
import {
  SiteLink,
} from '../../../types';


const useStyles = makeStyles((theme) => ({
  root: {
    padding: 10,
  },
}));


function SiteLinks(props: {screen: string}) {
  const classes = useStyles();
  const [links, setLinks] = useState([] as SiteLink[]);
  const [files, setFiles] = useState([] as SiteLink[]);
  const [isLoading, setIsloading] = useState(false);

  const loadInfos = async () => {
    const api = new BaseAPI();
    setIsloading(true);
    try {
      const infos = await api.get(`links/?screen=${props.screen}`);
      
      const newLinks: SiteLink[] = [];
      const newFiles: SiteLink[] = [];
  
      (infos as SiteLink[]).forEach((link) => {
        if (!link.file) newLinks.push(link);
        if (link.file) newFiles.push(link);
      })
  
      setLinks(newLinks);
      setFiles(newFiles);
    } catch (error) {
      console.error(error);
    }
    setIsloading(false);
  };
  useEffect(() => {
    loadInfos();
  }, [props.screen]);

  if ((links.length == 0) && (files.length == 0)) return (<></>);

  return (
  <Paper className={classes.root}>
    {links.length > 0 &&
    <List
      component="nav"
      aria-label={localization.links}
      subheader={
        <ListSubheader>
          {localization.links}
        </ListSubheader>
      }
    >
      {links.map((item, i) => {
        return (
          <ListItem button key={`libary-link-${i}`} onClick={() => window.open(item.url, '_blank')}>
            <ListItemIcon><OpenInNewIcon /></ListItemIcon>
            <ListItemText primary={item.title} />
          </ListItem>
        );
      })}
    </List>
    }
    {links.length > 0 && files.length > 0 &&
    <Divider />
    }
    {files.length > 0 &&
    <List
      component="nav"
      aria-label={localization.files}
      subheader={
        <ListSubheader>
          {localization.files}
        </ListSubheader>
      }
    >
      {files.map((item, i) => {
        return (
          <ListItem button key={`libary-link-${i}`} onClick={() => {
            if (item.file) window.open(item.file.file, '_blank')
          }}>
            <ListItemIcon><CloudDownloadIcon /></ListItemIcon>
            <ListItemText primary={item.title} />
          </ListItem>
        );
      })}
    </List>
    }
  </Paper>
  );
}

export {SiteLinks};